const translations = {
  welcome: {
    title: 'Welcome to {{sourceAcademyDeploymentName}}',
    loggedInMessage:
      'You have logged in as <0>{{name}}</0>. {{sourceAcademyDeploymentName}} does not have any course information for this account',
    enrollmentMessage:
      'If you are enrolled in a course, check with the course staff to make sure your account is added to the course.',
    resourcesForLearners: 'Click <0>here</0> to find a course that suits your needs.',
    resourcesForEducators: 'Click <0>here</0> for a list of resources to get started.',
  },
};

export default translations;
